module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/index/index.component.html
// module id = ./src/app/pages/index/index.component.html
// module chunks = main